import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '../../config/constants';

/**
 * 获取快捷注释
 **/
export function getQuickCommentsApi() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/predefined/comment`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 编辑快捷注释
 **/
export function editQuickCommentsApi(commentId, commentList) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/predefined/comment/${commentId}`,
        method: 'PUT',
        data: commentList,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getPatentViewCommentsListApi(patent_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}

export function editPatentViewCommentApi({
    patent_id,
    comment_text,
    comment_id,
    comment_to
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}/comment/${comment_id}`,
        method: 'PUT',
        data: {
            patent_id,
            comment_text,
            comment_id,
            comment_to
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function createPatentViewCommentApi({
    comment_by,
    comment_to,
    comment_to_id,
    comment_text,
    wording_id,
    patent_id
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}`,
        method: 'POST',
        data: {
            comment_by,
            comment_to,
            comment_text,
            comment_to_id,
            wording_id,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function deletePatentViewCommentApi({
    patent_id,
    comment_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/patent/${patent_id}/comment/${comment_id}`,
        method: 'DELETE',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取当前数据下的注释空间
 **/
export function getCommentsSpaceApi(data_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/list/with-comment/data/${data_id}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function addCommentApi({ folder_id, data_id, ...params }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/data/${data_id}`,
        method: 'POST',
        data: params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}


// 编辑注释, 来自workspace
export function updateCommentApi({ folder_id, data_id, comment_id, ...params }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/data/${data_id}/comment/${comment_id}`,
        method: 'PUT',
        data: params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 查询一条数据的注释，可以是PV/Eureka, 来自workspace
 **/
export function getSpaceCommentsFromWorkspaceApi({
    folder_id,
    data_id,
    visible_scope,
    filter_space_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/data/${data_id}?visible_scope=${visible_scope}&filter_space_id=${filter_space_id}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getCommentsApi({
    folder_id,
    data_ids = [],
    comment_limit = -1,
    data_type = 'PATENT',
    need_comment_structure = true,
    sort = 'ASC',
    visible_scope = 'ALL',
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/comment-list`,
        method: 'POST',
        data: {
            data_ids,
            comment_limit,
            data_type,
            need_comment_structure,
            sort,
            visible_scope,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getPatentViewCommentSpaceListApi({
    data_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/data/${data_id}/comment-space-list`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}
/**
 * 查询注释, 来自SRP
 **/
export function getSpaceCommentsFromSrpApi({
    data_id,
    visible_scope,
    filter_space_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/data/${data_id}`,
        method: 'GET',
        params: {
            visible_scope,
            filter_space_id
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 创建注释, 来自SRP
 **/
export function createCommentsFromSrpApi({
    data_id,
    comment_text,
    comment_to,
    comment_to_id,
    data_type,
    visible_scope,
    wording_id
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/data/${data_id}`,
        method: 'POST',
        data: {
            comment_text,
            comment_to,
            comment_to_id,
            data_type,
            visible_scope,
            wording_id
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除注释, 来自SRP
 **/
export function deleteCommentsFromSrpApi({
    comment_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/${comment_id}`,
        method: 'DELETE',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 编辑注释, 来自SRP
 **/
export function editCommentsFromSrpApi({
    data_id,
    comment_id,
    comment_text,
    data_type,
    visible_scope,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/data/${data_id}/comment/${comment_id}`,
        method: 'PUT',
        data: {
            comment_text,
            data_type,
            visible_scope,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}



/**
 * 获取注释, 来自workspace
 **/
export function getCommentsFromSpaceApi({
    data_id,
    folder_id,
    visible_scope,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/data/${data_id}?visible_scope=${visible_scope}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 创建注释, 来自workspace
 **/
export function createCommentsFromSpaceApi({
    data_id,
    folder_id,
    comment_text,
    comment_to,
    comment_to_id,
    data_type,
    visible_scope,
    wording_id
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/data/${data_id}`,
        method: 'POST',
        data: {
            comment_text,
            comment_to,
            comment_to_id,
            data_type,
            visible_scope,
            wording_id
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除注释, 来自workspace
 **/
export function deleteCommentsFromSpaceApi({
    comment_id,
    folder_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/comment/${comment_id}`,
        method: 'DELETE',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}
